import Vue from 'vue';
import { api } from '@/helpers/api';

export default {
  setMasterUpdateIndex({ commit }, { index }) {
    commit('setMasterUpdateIndex', index);
  },

  async loadAllMaterials({ commit }) {
    const response = await api.get('dictionary/application', {
      headers:
        { 'X-AUTH-TOKEN': process.env.VUE_APP_MATERIALS_TOKEN },
    });
    const { results } = response.data;
    commit('setAllMaterials', results);
  },

  clearAllMaterials({ commit }) {
    commit('clearAllMaterials');
  },

  clearRealizations({ commit }) {
    commit('clearRealizations');
  },

  async verifyMaterialsAuthorization() {
    const authToken = Vue.$cookies.get('auth-funpark');

    try {
      const authResponse = await api.get(`${process.env.VUE_APP_MATERIALS_URL}/?es-debug=${authToken}`, {
        transformRequest: (data, headers) => {
          // eslint-disable-next-line no-param-reassign
          delete headers.common['X-AUTH-TOKEN'];
          return data;
        },
      });
      return Promise.resolve(authResponse.data);
    } catch (error) {
      return Promise.resolve({ success: false, data: ['NETWORK'] });
    }
  },
};
